export default __webpack_public_path__ + "static/media/arnav.e38820ac.jpeg";